import {FC} from 'react'

import {parseInline} from '../../legal/legal-render'

type LegalInlineProps = {
  text: string
  /** Inside a booking the person must not lose the page they are on: open the legal page in a new tab. */
  newTab?: boolean
}

/** Renders a kit string ("[label](href)" and "**bold**") as text and plain anchors. No innerHTML. */
export const LegalInline: FC<LegalInlineProps> = ({text, newTab = false}) => (
  <>
    {parseInline(text).map((node, index) => {
      if (node.type === 'strong') {
        return <strong key={index}>{node.text}</strong>
      }
      if (node.type === 'link') {
        return (
          <a
            key={index}
            href={node.href}
            {...(newTab ? {target: '_blank', rel: 'noopener noreferrer'} : {})}
          >
            {node.text}
          </a>
        )
      }
      return <span key={index}>{node.text}</span>
    })}
  </>
)
